// extracted by mini-css-extract-plugin
export default {"referenceWrapper":"referenceWrapper--Q8B_4","wrapper":"wrapper--CuipZ"};